import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate("/"); // Redirige al login
  };

  return (
    <section className="container-navbar">
        <nav className="navbar">
          {user.name}
        </nav>
    </section>
  );
}
